var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-main-image" },
    [
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.img
          ? _c(
              "img",
              _vm._g(
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.show,
                      expression: "show",
                    },
                  ],
                  staticClass: "main-bg",
                  attrs: { src: _vm.img },
                },
                _vm.$listeners
              )
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }